
import * as React from 'react';
import {useEffect, useState} from "react";
import Formatter from "../../../util/formatter";
import {
    Button
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import AgyleDialog from "../../../components/modal/agyleDialog";
import {copyToClipboard} from "./hl7_console";
import Hl7utils from "./hl7utils";
import Hl7ViewJson from "./hl7_view_json";
import useOpenState from "../../../hooks/useOpenState";
import Hl7Messages from "./hl7_messages_comp";
import {ColumnTypes} from "./hl7_messages_comp";
import ColumnsManager, {getColumns} from "./columns_manager";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import {useSelector} from "react-redux";
import {agylePref} from "../../../store/reducers/preferences";
import _ from "lodash";


function Hl7inMessages(props){

    const {t} = useTranslation();
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);

    const [selectedRow, setSelectedRow] = React.useState(null);

    const [detailsModalIsVisible, setDetailsModalIsVisible] = useState(false);
    const [detailsMessage, setDetailsMessage] = useState(null);

    const openMessageDetails = (message) => {
        setDetailsMessage(message)
        setDetailsModalIsVisible(true);
    }

    const agylePreference = useSelector(agylePref);
    const [columns, setColumns] = React.useState([])

    useEffect(()=>{
        setColumns(getColumns(columnsInit, agylePreference?.inMessageColumnOrder));
    },[agylePreference]);

    const openJsonModal = (row) => {
        if(row.message) {
            setSelectedRow(row)
            openModal();
        } else {

        }
    }

    const copyJson = (row) => {
        let hl7obj1 =  Hl7utils.parseHl7ToJson( row.message);
        let hl7obj2 = {};
        for (let o1 of hl7obj1) {
            let segment = o1[0];
            hl7obj2[segment] = {};
            for (let i = 1; i < o1.length; i++) {
                hl7obj2[segment][`${segment}.${i}`] = o1[i];
            }
        }
        copyToClipboard(JSON.stringify(hl7obj2, null, 2))
    }



    const columnsInit = [
        {
            name: 'action',
            order: 1,
            value: 'action',
            type: ColumnTypes.CHEACKBOX,
            description: 'Info',
            minWidth: 30
        },
        {
            name: '_createdDate',
            order: 1,
            value: '_createdDate',
            type: ColumnTypes.TEXT,
            description: 'Created Date',
            minWidth: 10,
            maxWidth: 175,
            sort: true,
            defaultSort: true,
            format: (value) => {
                return Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss", "");
            }},
        {
            name: 'dateTime',
            order: 1,
            value: 'dateTime',
            type: ColumnTypes.TEXT,
            withMessage: true,
            description: 'Date',
            minWidth: 10,
            maxWidth: 175,
            sort: true,
            defaultSort: true,
            format: (value) => {
                return Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss", "");
            }},
        {
            name: 'messageType',
            order: 1,
            value: 'messageType',
            type: ColumnTypes.TEXT,
            description: 'Type',
            sort: true,
            minWidth: 10 },
        {
            name: 'hospitalNumber',
            order: 1,
            value: 'hospitalNumber',
            type: ColumnTypes.TEXT,
            description: 'Hospital number',
            sort: true,
            minWidth: 10 },
        {
            name: 'attendanceId' ,
            order: 1,
            value: 'attendanceId',
            type: ColumnTypes.TEXT,
            description: 'Attendance',
            sort: true,
            minWidth: 10 },
        {
            name: 'system',
            order: 1,
            value: 'system',
            type: ColumnTypes.TEXT,
            description: 'System',
            sort: true,
            minWidth: 10 },
        {
            name: 'hl7ServiceVersion',
            order: 1,
            value: 'hl7ServiceVersion',
            type: ColumnTypes.TEXT,
            description: 'Version',
            sort: true,
            minWidth: 10 },
        {
            name: 'actions',
            order: 1,
            value: 'actions',
            type: ColumnTypes.ACTIONS,
            actionList: [
                {   callback: openMessageDetails,
                    buttonLabel: "Details"
                },
                {   callback: openJsonModal,
                    buttonLabel: "Show JSON"
                },
                {   callback: copyJson,
                    buttonLabel: "Copy JSON"
                }
            ],
            description: 'Actions',
            minWidth: 10 },

    ];




    const handleCloseMessageDetails = () =>{
        setDetailsModalIsVisible(false);
    }


    const renderDetailsModal = () => {
        return ( <AgyleDialog
            title={t("Message Details")}
            open={detailsModalIsVisible}
            width={"md"}
            fullWidth
            onClose={handleCloseMessageDetails}
            disableSave
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={t("Date Time")}
                        defaultValue={Formatter.utcAndLocalFormatData(detailsMessage.dateTime,"YYYY-MM-DD HH:mm:ss", "")}
                        variant="outlined"
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={t("Type")}
                        defaultValue={detailsMessage.messageType}
                        variant="outlined"
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={t("Hospital Number")}
                        defaultValue={detailsMessage.hospitalNumber}
                        variant="outlined"
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={t("Attendance")}
                        defaultValue={detailsMessage.attendanceId}
                        variant="outlined"
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={t("Message")}
                        defaultValue={detailsMessage.message}
                        variant="outlined"
                        disabled
                        multiline
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={t("System")}
                        defaultValue={detailsMessage.system}
                        variant="outlined"
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={t("Version")}
                        defaultValue={detailsMessage.version}
                        variant="outlined"
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sx={{mt: 2}}>
                    <Grid container xs={12} spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={2}>
                        <Button
                        size={'medium'}
                        fullWidth
                        variant='outlined'
                        disabled={!detailsMessage.message}
                        onClick={()=> copyJson(detailsMessage)}
                        sx={{color: "#448FFF", borderColor: 'transparent', boxShadow: '0 0 4px grey', "&:hover": {borderColor: 'transparent'}}}
                        >
                            {t('Copy JSON')}
                        </Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                        size={'medium'}
                        fullWidth
                        variant='outlined'
                        disabled={!detailsMessage.message}
                        onClick={() => {copyToClipboard(detailsMessage.message)}}
                        sx={{color: "#448FFF", borderColor: 'transparent', boxShadow: '0 0 4px grey', "&:hover": {borderColor: 'transparent'}}}
                        >
                            {t('Copy RAW')}
                        </Button>
                    </Grid>
                </Grid>
                </Grid>
            </Grid>
        </AgyleDialog>)
    }


    const getMessage = (row) => {
        return row.message
    }

    const sortColumn = () => {
        const filteredColumns = _.filter(columns, col => {
            return !_.isNil(col.order);
        });

        return _.sortBy(filteredColumns, obj => {
            return obj.order;
        });
    };


    const [openConfig, setOpenConfig] = React.useState(false);

    return (<div>

        {/*<IconButton*/}
        {/*    size={"small"}*/}
        {/*    disableRipple={true}*/}
        {/*    onClick={() => setOpenConfig(true)}>*/}
        {/*    <SettingsIcon/>*/}
        {/*</IconButton>*/}

        <ColumnsManager prefPath={"inMessageColumnOrder"}
                        columns = {columns}
                        title={"Incoming Messages Columns Settings"}
                        columnsInit = {columnsInit}
                        openConfig={openConfig}
                        closeModal={() => setOpenConfig(false)}/>

        <Hl7Messages table = {"hl7Log"} openColumnManager={() => setOpenConfig(true)} webSocketChanel = {"db_hl7_incoming_messages"} columns={sortColumn()} messagePath={getMessage} {...props}/>

        {detailsMessage && renderDetailsModal()}
        {selectedRow && <Hl7ViewJson isOpen = {isModalOpen} handleCloseModal = {closeModal} message = {selectedRow.message}/>}

    </div>);
}

export default Hl7inMessages;